import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, retry } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiHttpClient {
  private baseUrl: string;
  
  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }
  
  /**
   * Realiza una petición GET
   * @param endpoint Endpoint relativo a la URL base
   * @param params Parámetros de la petición
   * @param retryCount Número de reintentos en caso de error
   */
  get<T>(endpoint: string, params?: Record<string, string | number | boolean | null | undefined>, retryCount = 1): Observable<T> {
    const url = this.buildUrl(endpoint);
    const httpParams = this.buildParams(params);
    
    return this.http.get<T>(url, { params: httpParams })
      .pipe(retry(retryCount));
  }
  
  /**
   * Realiza una petición POST
   * @param endpoint Endpoint relativo a la URL base
   * @param body Cuerpo de la petición
   * @param retryCount Número de reintentos en caso de error
   */
  post<T>(endpoint: string, body: unknown, retryCount = 0): Observable<T> {
    const url = this.buildUrl(endpoint);
    
    return this.http.post<T>(url, body)
      .pipe(retry(retryCount));
  }
  
  /**
   * Realiza una petición PUT
   * @param endpoint Endpoint relativo a la URL base
   * @param body Cuerpo de la petición
   * @param retryCount Número de reintentos en caso de error
   */
  put<T>(endpoint: string, body: unknown, retryCount = 0): Observable<T> {
    const url = this.buildUrl(endpoint);
    
    return this.http.put<T>(url, body)
      .pipe(retry(retryCount));
  }
  
  /**
   * Realiza una petición DELETE
   * @param endpoint Endpoint relativo a la URL base
   * @param params Parámetros de la petición
   * @param retryCount Número de reintentos en caso de error
   */
  delete<T>(endpoint: string, params?: Record<string, string | number | boolean | null | undefined>, retryCount = 0): Observable<T> {
    const url = this.buildUrl(endpoint);
    const httpParams = this.buildParams(params);
    
    return this.http.delete<T>(url, { params: httpParams })
      .pipe(retry(retryCount));
  }
  
  /**
   * Construye la URL completa
   */
  private buildUrl(endpoint: string): string {
    return `${this.baseUrl}/${endpoint}`.replace(/\/+/g, '/').replace('http:/', 'http://').replace('https:/', 'https://');
  }
  
  /**
   * Construye los parámetros HTTP
   */
  private buildParams(params?: Record<string, string | number | boolean | null | undefined>): HttpParams {
    let httpParams = new HttpParams();
    
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          httpParams = httpParams.set(key, String(params[key]));
        }
      });
    }
    
    return httpParams;
  }
}
